/**
 * Grid data/filter types
 * @module components/Grid/types
 *
 */

import Vue from 'vue'
import TextFilter from './filters/text'
// import DateFilter from './filters/date'

export default {
  /**
   *
   */
  text: {
    filter: Vue.extend(TextFilter)
  },

  date: {
    column(c) {
      if (c.value) {
        const ts = c.value.split('Date(') && c.value.split('Date(')[1].split(')')[0]
        return new Date(+ts).toLocaleDateString()
      } else return null
    }

    // filter: Vue.extend(Date)
  }
}



// WEBPACK FOOTER //
// ./src/components/Grid/data-types.js